import * as THREE from "three";

// The Sun's real angular radius is ~0.2666°. Placing it at SUN_SCENE_DIST
// (inside the starfield sphere at 4,000, beyond the Moon at 1,200) with this
// radius keeps its apparent size true — the same trick moon.js uses.
const SUN_SCENE_DIST = 3_000;
export const SUN_RADIUS = SUN_SCENE_DIST * Math.tan((0.2666 * Math.PI) / 180); // ≈ 14

// Radiance of the disc: the sunlight's irradiance (the scene's 2.0) spread
// over the Sun's true solid angle, ~29,000 times it. Far past white, as the
// real Sun is; the lens flare (lens-flare.js) adds the glare.
export const SUN_RADIANCE = 2.0 / (Math.PI * Math.tan((0.2666 * Math.PI) / 180) ** 2);

/**
 * Builds a visible Sun disc and adds it to the scene. Lighting still comes
 * from Globe's sunLight; this is only the thing you see in the sky. Earth
 * occludes it through normal depth testing.
 *
 * Returns:
 *   update(sunDir) — reposition when the date changes (unit vector toward the sun)
 *   setTransmittance([r, g, b]) — colour of the air it's seen through
 */
export function createSunMesh(scene, initialSunDir) {
  const group = new THREE.Group();

  const disc = new THREE.Mesh(
    new THREE.SphereGeometry(SUN_RADIUS, 32, 32),
    new THREE.MeshBasicMaterial({ toneMapped: false })
  );
  disc.material.color.setScalar(SUN_RADIANCE);
  group.add(disc);

  const update = (sunDir) => {
    group.position.copy(sunDir).normalize().multiplyScalar(SUN_SCENE_DIST);
  };

  const setTransmittance = ([r, g, b]) => {
    disc.material.color.setRGB(r, g, b).multiplyScalar(SUN_RADIANCE);
  };

  update(initialSunDir);
  scene.add(group);

  return { group, update, setTransmittance };
}
